import { User, UsersThree } from "@phosphor-icons/react";
import { useLocale } from "@/i18n";

export default function ProfessionalStep({ professionals, selected, onSelect }) {
  const { t } = useLocale();

  return (
    <div className="mb-6" data-testid="professional-step">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-500 mb-3">{t("prof_pick")}</p>
      <div className="flex gap-3 overflow-x-auto no-scrollbar -mx-4 px-4 pb-1">
        <button
          data-testid="professional-any"
          onClick={() => onSelect(null)}
          className={`shrink-0 flex flex-col items-center gap-1.5 w-20 transition-opacity ${selected === null ? "" : "opacity-50 hover:opacity-80"}`}
        >
          <span className={`w-16 h-16 rounded-full border-2 flex items-center justify-center transition-colors ${selected === null ? "border-amber-500 bg-amber-500/15" : "border-zinc-700 bg-zinc-900"}`}>
            <UsersThree size={24} weight="duotone" className={selected === null ? "text-amber-500" : "text-zinc-500"} />
          </span>
          <span className={`text-[11px] font-semibold text-center leading-tight ${selected === null ? "text-amber-500" : "text-zinc-400"}`}>{t("prof_any")}</span>
        </button>
        {professionals.map((p) => (
          <button
            key={p.id}
            data-testid={`professional-option-${p.id}`}
            onClick={() => onSelect(p)}
            className={`shrink-0 flex flex-col items-center gap-1.5 w-20 transition-opacity ${selected?.id === p.id ? "" : "opacity-50 hover:opacity-80"}`}
          >
            {p.photo_url ? (
              <img src={p.photo_url} alt={p.name} className={`w-16 h-16 rounded-full object-cover border-2 transition-colors ${selected?.id === p.id ? "border-amber-500" : "border-zinc-700"}`} />
            ) : (
              <span className={`w-16 h-16 rounded-full border-2 flex items-center justify-center transition-colors ${selected?.id === p.id ? "border-amber-500 bg-amber-500/15" : "border-zinc-700 bg-zinc-900"}`}>
                <User size={24} weight="duotone" className={selected?.id === p.id ? "text-amber-500" : "text-zinc-500"} />
              </span>
            )}
            <span className={`text-[11px] font-semibold text-center leading-tight truncate w-full ${selected?.id === p.id ? "text-amber-500" : "text-zinc-400"}`}>{p.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
